import config from '@/config.js';
let app_name = config.name;
let route = {}
if (app_name === 'rms_ui') {
    route = {
        exclude_paths: false,
        paths: [
            '/',
            '/*',
            '/*/*',
            '/*/*/*'
        ],
        roles: [
            'admin'
        ],
        region: 'header', //header|topA|topB|left|mainTop|mainBottom|right|bottomB|bottomA|footer
        preload: false,
        weight: 1
    }
} else {
    route = {
        exclude_paths: false,
        paths: [],
        region: 'header', //header|topA|topB|left|mainTop|mainBottom|right|bottomB|bottomA|footer
        preload: false,
        weight: 1
    }
}

export default route